import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatGridListModule} from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';


@NgModule({
  declarations: [],
  imports: [    
    MatCardModule, MatDividerModule, MatSnackBarModule, MatMenuModule,
    MatFormFieldModule, MatInputModule, MatButtonModule, MatCheckboxModule,
    MatSidenavModule, MatToolbarModule, MatIconModule, MatListModule,
    MatTableModule, MatSelectModule, MatPaginatorModule, MatSortModule,
    MatDatepickerModule, MatNativeDateModule, MatGridListModule
  ], 
  exports:[
    MatCardModule, MatDividerModule, MatSnackBarModule, MatMenuModule,
    MatFormFieldModule, MatInputModule, MatButtonModule, MatCheckboxModule,
    MatSidenavModule, MatToolbarModule, MatIconModule, MatListModule,
    MatTableModule, MatSelectModule, MatPaginatorModule, MatSortModule,
    MatDatepickerModule, MatNativeDateModule, MatGridListModule
  ]
})
export class MyMaterialModule { }
